import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { HousingArrangementsStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof HousingArrangementsStateValues>[] = [
  {
    type: 'select',
    name: 'rentOrOwn',
    label:
      'Did you rent or own your primary foreign (i.e. non-US) residence during the filing year?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    options: [
      { label: 'Rent', value: 'Rent' },
      { label: 'Own', value: 'Own' },
      {
        label: 'Employer Provided Residence',
        value: 'Employer Provided Residence',
      },
    ],
    dependencies: [
      {
        type: 'currency',
        name: 'rentAmount',
        label:
          'What was the rent and utilities you paid on the foreign (i.e Non-US) residence for entire year?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'Rent',
      },
      {
        type: 'radio',
        name: 'employerPayedForResidence',
        label: 'Did your employer pay for your residence?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'Rent' || value === 'Own',
        dependencies: [
          {
            type: 'radio',
            name: 'employerProvidedSubsidy',
            label: 'Did your employer provide you with a subsidy for housing?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'no',
            dependencies: [
              {
                type: 'radio',
                name: 'employerProvidedSubsidyAmount',
                label: 'How much was the housing subsidy?',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                predicate: (value) => value === 'yes',
              },
            ],
          },
        ],
      },
      {
        type: 'radio',
        name: 'familyMembersLivingWithYou',
        label:
          'Did any of your family members live with you during the filing year?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) =>
          value === 'rent' ||
          value === 'own' ||
          value === 'Employer Provided Residence',
        dependencies: [
          {
            type: 'text',
            name: 'familyMembersName',
            label: 'Please list their names',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter',
          },
        ],
      },
      {
        type: 'radio',
        name: 'employerProvidedResidence',
        label:
          'Is living in employer provided residence a condition for employment?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'Employer Provided Residence',
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
